import { createRouter, createWebHistory } from "vue-router";
import { i18nService } from "@/service/i18n";
import { sdkService } from "@/service/sdk";
import { grayService } from "@/service/gray";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", redirect: "/index" },
    {
      path: "/home",
      name: "home",
      component: () => import("@/views/index/home.vue"),
      children: [
        {
          // 常见问题
          path: "/common-problem",
          name: "common-problem",
          component: () => import("@/views/common-problem/index.vue"),
          meta: { menu: true },
        },
        {
          // 常见问题-明细页
          path: "/common-problem-detail",
          name: "common-problem-detail",
          component: () => import("@/views/common-problem/detail.vue"),
        },
        {
          // 联系客服
          path: "/contact-service",
          name: "contact-service",
          component: () => import("@/views/contact-service/index.vue"),
          meta: { menu: true },
        },
        {
          // 反馈列表
          path: "/feedback",
          name: "feedback",
          component: () => import("@/views/feedback-list/index.vue"),
          meta: { menu: true },
        },
        {
          // 反馈详情
          path: "/feedback-detail",
          name: "feedback-detail",
          component: () => import("@/views/feedback-detail/index.vue"),
        },
      ],
    },
    {
      path: "/index",
      name: "index",
      component: () => import("@/views/index/index.vue"),
      children: [
        {
          // SDK登陆前，手机校验
          path: "/sdk-login-before/mobile",
          name: "sdk-login-before-mobile",
          component: () => import("@/views/sdk-login-before/mobile.vue"),
        },
        {
          // SDK登陆前，邮箱校验
          path: "/sdk-login-before/email",
          name: "sdk-login-before-email",
          component: () => import("@/views/sdk-login-before/email.vue"),
        },
        {
          // SDK登录后进入游戏前
          path: "/sdk-login-after",
          name: "sdk-login-after",
          component: () => import("@/views/sdk-login-after/index.vue"),
        },
        {
          // 飞鱼游戏公众号入口
          path: "/feiyu-wechat-enter",
          name: "feiyu-wechat-enter",
          component: () => import("@/views/feiyu-wechat-enter/index.vue"),
        },
      ],
    },
    {
      // b端调用联系客服页面预览功能
      path: "/preview-cs",
      name: "preview-cs",
      component: () => import("@/views/contact-service/index.vue"),
    },
    {
      // 七鱼客服常见问题
      path: "/knowledge",
      name: "knowledge",
      component: () => import("@/views/knowledge/index.vue"),
    },
    {
      // 七鱼客服常见问题-明细页
      path: "/knowledge-detail",
      name: "knowledge-detail",
      component: () => import("@/views/knowledge/detail.vue"),
    },
  ],
});

// 钩子函数统一处理全局系统参数
router.beforeEach((to, from, next) => {
  //浏览器标题设置
  if (to.path === "/feedback" && to.query.type === "allfb") {
    // 微信客服头部进入反馈列表，不显示底部栏
    to.meta.menu = false;
  }
  document.title = i18nService.translate("global_config.project_title");
  if (to.query._next) {
    grayService.updateVisitEnv();
    return next();
  }

  // 支持链接刷新保留参数
  const query: Record<string, string> = { _next: "1", ...to.query };
  for (const key in sdkService.options) {
    const sdkOptons = sdkService.options as Record<string, unknown>;
    query[`_${key}`] = sdkOptons[key] as string;
  }

  return next({ ...to, query });
});
export default router;
